import arrayFrom from 'array-from';
import 'custom-event-polyfill';
import elementClosest from 'element-closest';
import 'ie-array-find-polyfill';
import 'objectFitPolyfill';
import 'picturefill';
import 'picturefill/dist/plugins/typesupport/pf.type';
import 'polyfill-array-includes';
import 'promise-polyfill/src/polyfill';
import svg4everybody from 'svg4everybody';
import 'url-polyfill';
import 'whatwg-fetch';

if (!Array.from) {
	Array.from = arrayFrom;
}

elementClosest(window);

svg4everybody();
